import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSwitch,_vm._g(_vm._b({staticClass:"w-switch--selection",class:{ 'w-switch--selection--has-label': _vm.$props.label },attrs:{"label":_vm.computedLabel,"disabled":_vm.readonly,"hide-details":""},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'v-switch',_vm.filteredProps,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }